import axios from 'axios';
import qs from 'qs';
import { showToast } from 'vant';
import { addSignature } from '@/utils/signature';
import { useUserStore } from '@/stores';
import { isApp } from '@/utils/tools';
import router from '@/router';
import { isKeXieApp, loginByKeXieApp } from '@/utils/ccwork';

const instance = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_API,
  showToast: true,
  // 添加签名
  addSignature: true,
  // 添加token
  addToken: true,
  // 下载文件
  download: false,
  // 请求延迟时长，单位毫秒，默认0
  delayRequestTime: 0,
  // 响应延时时长，单位毫秒，默认0
  delayResponseTime: 0,
  withCredentials: true,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
  // 在向服务器发送前，转换请求数据
  transformRequest: [
    function (data, headers) {
      if (
        data &&
        headers['Content-Type'] === 'application/x-www-form-urlencoded'
      ) {
        for (const [key, value] of Object.entries(data)) {
          if (Object.prototype.toString.call(value) === '[object Object]') {
            data[key] = JSON.stringify(value);
          }
        }
        data = qs.stringify(data);
      }
      return data;
    },
  ],
});

instance.interceptors.request.use(
  (config) => {
    const userStore = useUserStore();

    if (config.addToken) {
      if (config.params) {
        config.params.token = userStore.token || '';
      } else {
        config.params = {
          token: userStore.token || '',
        };
      }
    }
    if (config.addSignature) {
      // 为API增加签名
      config = addSignature(config);
    }

    if ((config.delayRequestTime || 0) > 0) {
      return delay(config, config.delayRequestTime);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (response.status && response.status !== 200) {
      return Promise.reject(res || 'error');
    } else {
      if (response.config.download) {
        return Promise.resolve(response);
      }

      if (res.code === 0) {
        if ((response.config.delayResponseTime || 0) > 0) {
          return delay(res, response.config.delayResponseTime);
        }
        return Promise.resolve(res);
      }

      if (res.code === 100000099 || res.code === 100000010) {
        res.errorMsg = '';
        const userStore = useUserStore();
        userStore.resetLoginUser();
        if (isApp()) {
          window.sma?.login?.();
        } else if (isKeXieApp()) {
          loginByKeXieApp();
        } else {
          showToast({
            message: '请登录',
            wordBreak: 'break-word',
          });
          router?.push({
            path: '/login',
            query: {
              redirect: router?.currentRoute.value?.fullPath ?? '',
            },
          });
        }
      } else {
        res.errorMsg =
          Array.isArray(res.error) && res.error.length > 0
            ? res.error[0].value
            : res.data
              ? res.data.name || res.msg
              : res.msg;
      }

      if (response.config.showToast && res.errorMsg) {
        showToast({
          message: res.errorMsg,
        });
      }

      return Promise.reject(res);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 延迟
function delay<T>(obj: T, ms = 0) {
  return new Promise<T>((resolve) => {
    setTimeout(() => resolve(obj), ms);
  });
}

export default instance;
